import { post, get, postJson, put } from '../axios';
const RESOURCE_BASE_PATH = '/perspectiveSku';

// 移除商品透视sku
export const deleteSkuBatch = p => postJson(`${RESOURCE_BASE_PATH}/deleteSkuBatch`, p);

// 商品交易透视导出
export const exportPerspective = p => get(`${RESOURCE_BASE_PATH}/export`, p);

// 分页获取商品透视sku
export const getPerspectiveSkuPage = p => post(`${RESOURCE_BASE_PATH}/getPerspectiveSkuPage`, p);

// 商品交易透视分页查询、 商品交易透视其他商品弹框分页查询
export const orderNumPage = p => get(`${RESOURCE_BASE_PATH}/orderNumPage`, p);

// 添加商品透视sku
export const saveSkuBatchsaveSkuBatch = p => postJson(`${RESOURCE_BASE_PATH}/saveSkuBatch`, p);

// 商品交易透视分页查询、 商品交易透视其他商品弹框分页查询
export const otherNumPage = p => get(`${RESOURCE_BASE_PATH}/otherNumPage`, p);
